import { UPDATE_VC_PAGE_VISIBILITY } from '~/actions/vcAppActions/vcAppActionsTypes/types';

export const updateVCPageVisibility = (isVisible: boolean) => ({
  type: UPDATE_VC_PAGE_VISIBILITY,
  isVisible,
});
